import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AnnouncementService} from "../../../../../shared/services/announcement.service";
import {Announcement, AnnouncementFormInt, AnnouncementInt} from "../../interfaces/announcement";
import {ModalComponent} from "../../../../../modal/modal.component";
import {Subscription} from "rxjs";
import {SubmissionSearchUserInfoObject} from "../../../search-object";
import {SubmissionHistoryService} from "../../../../../shared/services/submission-history.service";

@Component({
    selector: 'announcement-page',
    templateUrl: './announcement-page.component.html',
    styleUrls: ['./announcement-page.component.scss'],
    providers: [AnnouncementService]
})

export class AnnouncementPage  {

    userInfo: SubmissionSearchUserInfoObject = new SubmissionSearchUserInfoObject();
    private        userInfoSubscription: Subscription;
    cancelTitle = 'Changes Will Not Be Saved';

    sourceModalContent: string;

    public model: Object;
    public name = '';
    private announcement: Announcement;
    private initial: AnnouncementFormInt;
    protected edited = false;
    protected enabled = true;

    private value;
    constructor(
        private readonly route: ActivatedRoute,
        private readonly service: AnnouncementService,
        private submissionHistoryService: SubmissionHistoryService,
        private readonly router: Router,
    ) {
    }

    ADMIN_ANNOUNCEMENTS_PAGE = '/admin/announcements';

    @ViewChild('announcement', {static: false}) announcementRef;

    @ViewChild('cancelUpdateAnnouncement')
    private readonly modal: ModalComponent;


    private readonly loading = this.service.getAnnouncement(this.route.snapshot.paramMap.get('id')).subscribe(data => {
        const announcementInt: AnnouncementInt = data;
        this.model = this.service.modelPreparing(announcementInt, null);
        this.initial = Object.assign({}, this.model as AnnouncementFormInt);
        this.announcement = data.announcement;
        this.name = announcementInt.announcementTitle;
    });

    ngOnInit(): void {
        document.title = 'Announcement Details';
        this.userInfoSubscription = this.submissionHistoryService.currentUserInfo.subscribe(message => {this.userInfo = message})
   }

    public onEdit() {
        this.value = this.announcementRef.Form.value;
        this.edited = true;
    };

    public onSubmit() {
        const model = this.announcementRef.Form.value;
        const id = model.announcement.announcementId;
        this.service.prepareTime(model);
        this.service.updateAnnouncement(model.announcement).subscribe(() => {
            },
            error => {
                if (error.status < 500) {
                    console.error("Errors updating announcement.")
                }
            }, () => {
                // on completion of base update...
                if (id !== '0') {
                    this.service.updateMappingToReportingCenter(id, model.announcement.reportingCenters).subscribe(() => {
                            console.log(`Saved new centers for announcement ${id}`);
                        },
                        error => {
                            if (error.status < 500) {
                                console.error("Error updating reporting center mapping.")
                            }
                        }, () => {
                            // on completion of reporting center update...
                            this.edited = false;
                            this.router.navigateByUrl(this.ADMIN_ANNOUNCEMENTS_PAGE);
                        });
                }
            });
    };

    public onCancel() {
        const form = this.announcementRef.Form;
        if (form.pristine) {
            this.edited = false;
        } else {
            this.modal.open();
        }
    };

    public cancelEditAnnouncement() {
        const initial = this.initial;
        this.initial = Object.assign({}, initial);
        this.model = initial;
        this.edited = false;
        this.modal.close();
    }
}
